import React, { Component } from 'react';
import styles from './BrandsTableLine.module.scss';
import { IconButton, Tag, Picture, WarningMessage } from 'components';
import { icons, sizes } from 'assets';
import { inject } from 'mobx-react';
import { ROUTING_STORE } from 'store';
import { RouterStore } from 'mobx-react-router';
import moment from 'moment';
import { getMainImageSrcForObj } from 'utilities';

interface Props {
  brand: any;
  [ROUTING_STORE]?: RouterStore;
}

class BrandsTableLine extends Component<Props> {
  render() {
    const {
      brand,
      [ROUTING_STORE]: { push }
    } = this.props;

    return (
      <div
        className={styles.tableRow}
      >
        <div
          className={styles.nameContainer}
          onClick={() => push(`/brands/edit/${brand.id}`)}
        >
          <Picture
            size={35}
            src={getMainImageSrcForObj(brand)}
          />
          <h4>{brand.name}</h4>

          <WarningMessage
            object={brand}
            objectType='brand'
          />

        </div>

        <div style={{ width: sizes.projectsTableAddedAtWidth }}>
          {moment(brand.createdDate).format('HH:mm, DD.MM.YYYY')}
        </div>

        <div style={{ width: sizes.projectsTableTagsWidth }}>
          {brand.tags &&
            brand.tags.split(',').map((tag, index) =>
              <Tag key={index} tag={tag} />
            )
          }
        </div>

        <div>{brand.numberProducts}</div>

        <div className={styles.buttonsContainer}>
          {brand.numberProducts
            ? <IconButton
              icon={icons.tShirt}
              title='Products'
              className={styles.optionButton}
              onClick={() => push(`/products/${brand.id}`)}
            />
            : null
          }
          <IconButton
            icon={icons.pen}
            title='Edit brand'
            className={styles.optionButton}
            onClick={() => push(`/brands/edit/${brand.id}`)}
          />
        </div>

      </div>
    );
  }
}

export default inject(ROUTING_STORE)(BrandsTableLine);
